import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from './../redux/hooks';
import { useTheme } from '../themeContext';

// -- Redux

// -- Components

import Notification from '../components/general/notification/Notification';
import NavBar from '../components/general/navBar/NavBar';
import DoctorSettings from '../components/doctor/navigation/navBar/Settings';
// import Container from '../components/consultation/Container';
// import Sidebar from '../components/general/navigation/Sidebar'; // Sidebar is now handled within Container
import Container from '../components/consultation/updated/Container';
import Consent from '../components/consultation/updated/popups/Consent';
import NoteViewer from '../components/consultation/updated/popups/NoteViewer';
import Language from '../components/consultation/updated/popups/Language';
import NoteDeletion from '../components/consultation/updated/popups/NoteDeletion';
import Settings from '../components/consultation/updated/popups/Settings';
import FileExplorer from '../components/consultation/updated/popups/FileExplorer';
// import NoteEditing from '../components/consultation/updated/popups/NoteEditing';
import QrCode from '../components/consultation/updated/popups/QrCode';
import LockScreenWarning from '../components/lockScreen/warning/LockScreenWarning';
import FileViewer from '../components/doctor/dashboard/viewers/file/FileViewer';
import Export from '../components/consultation/updated/popups/Export';
import LoadingPopup from '../components/general/popups/LoadingPopup';
import Page from '../components/general/containers/Page';
import NoteType from '../components/consultation/updated/popups/NoteType';
import Fax from '../components/consultation/updated/popups/Fax'; // --- 1. IMPORT THE NEW FAX POPUP

const Consultation: React.FC = () => {

  const dispatch = useAppDispatch();

  const colors = useAppSelector(state => state.theme.colors);

  const isConsentPopupOpened = useAppSelector(state => state.consultation.isConsentPopupOpened);
  const isNoteViewerOpened = useAppSelector(state => state.consultation.isNoteViewerOpened);
  const isLanguagePopupOpened = useAppSelector(state => state.consultation.isLanguagePopupOpened);
  const isNoteDeletionPopupOpened = useAppSelector(state => state.consultation.isNoteDeletionPopupOpened);
  const isSettingsPopupOpened = useAppSelector(state => state.consultation.isSettingsPopupOpened);
  const isFileExplorerPopupOpened = useAppSelector(state => state.consultation.isFileExplorerPopupOpened);
  // const isNoteEditingPopupOpened = useAppSelector(state => state.consultation.isNoteEditingPopupOpened);
  const isQrCodePopupOpened = useAppSelector(state => state.consultation.isQrCodePopupOpened);
  const isNoteExportPopupOpened = useAppSelector(state => state.consultation.isNoteExportPopupOpened);
  const isLockScreenWarningPopupOpened = useAppSelector(state => state.navigation.isLockScreenWarningPopupOpened); 
  const isNoteTypePopupOpened = useAppSelector(state => state.consultation.isNoteTypePopupOpened);
  const isFaxPopupOpened = useAppSelector(state => state.consultation.isFaxPopupOpened); // --- 2. GET THE FAX POPUP STATE FROM REDUX

  const isLoadingPopupOpened = useAppSelector(state => state.navigation.isLoadingPopupOpened);

  const isFileViewerOpened = useAppSelector(state => state.fileViewer.isFileViewerOpened);


  const { isLightMode, toggleTheme } = useTheme();

  const navigate = useNavigate();
  const { t } = useTranslation();

  // --

  return (

    <Page>

        {/* Container now handles Sidebar logic internally */}
        <Container />

        <NavBar>
            <DoctorSettings />
        </NavBar>

        {isConsentPopupOpened && <Consent />}

        {isNoteViewerOpened && <NoteViewer />}

        {isLanguagePopupOpened && <Language />}

        {isNoteTypePopupOpened && <NoteType />}

        {isNoteDeletionPopupOpened && <NoteDeletion />}

        {isSettingsPopupOpened && <Settings />}

        {isFileExplorerPopupOpened && <FileExplorer />}

        {isNoteExportPopupOpened && <Export />}

        {isFaxPopupOpened && <Fax />} {/* --- 3. RENDER THE FAX POPUP CONDITIONALLY --- */}

        {/* {isNoteEditingPopupOpened && <NoteEditing />} */}

        {isQrCodePopupOpened && <QrCode />}

        {isLoadingPopupOpened && <LoadingPopup />}

        {isFileViewerOpened && <FileViewer />}

        {/* <Sidebar /> */} {/* Removed, handled by Container */}

        {isLockScreenWarningPopupOpened && <LockScreenWarning />}

    </Page>

  );
};

export default Consultation;